module.exports = __webpack_public_path__ + "static/media/Reload-btn.5b1acee1.svg";